module.exports = __webpack_public_path__ + "img/trip_sendai13.f04f7300.jpg";